import { PageHero } from "@/components/site/PageHero";
import { Reveal, SectionLabel } from "@/components/site/primitives";
import { LEADERS } from "@/data/content";

export default function Leadership() {
  return (
    <div data-testid="leadership-page">
      <PageHero
        label="Leadership Team"
        titleLines={["The people", "behind the", "mission"]}
        intro="A leadership team pairing strategic operations, consultancy depth, and field-execution expertise to drive sustainable urban outcomes."
        testId="leadership-hero"
      />

      <section className="px-5 md:px-10 py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto space-y-px bg-raritan-border border border-raritan-border">
          {LEADERS.map((l, i) => (
            <Reveal key={l.name} delay={i * 0.08}>
              <div className="bg-raritan-surface grid lg:grid-cols-12 gap-8 p-8 md:p-12 group hover:bg-raritan-green-soft transition-colors duration-500">
                <div className="lg:col-span-3 flex lg:flex-col items-center lg:items-start gap-5">
                  <div className="relative w-32 h-40 md:w-full md:h-auto md:aspect-[3/4] overflow-hidden border border-raritan-border shrink-0">
                    <img
                      src={l.photo}
                      alt={l.name}
                      style={{ objectPosition: l.objectPos || "center top", transform: l.zoom ? `scale(${l.zoom})` : undefined, transformOrigin: l.origin || "center" }}
                      className={`w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 ${l.zoom ? "" : "scale-100 group-hover:scale-105"}`}
                    />
                  </div>
                  <span className="font-mono text-sm text-raritan-red">0{i + 1}</span>
                </div>
                <div className="lg:col-span-6">
                  <h3 className="font-heading font-black uppercase tracking-tight text-3xl md:text-4xl text-raritan-ink">{l.name}</h3>
                  <p className="mt-2 font-mono text-xs uppercase tracking-[0.15em] text-raritan-green">{l.title}</p>
                  <p className="mt-6 font-body text-lg text-raritan-muted leading-relaxed">{l.bio}</p>
                </div>
                <div className="lg:col-span-3">
                  <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-raritan-muted">Focus areas</span>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {l.focus.map((f) => (
                      <span key={f} className="font-mono text-[11px] uppercase tracking-[0.1em] border border-raritan-border px-3 py-1.5 text-raritan-ink">{f}</span>
                    ))}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
